import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Login.css';

function Login({ setUserId, setMessage, setIsAuthenticated }) {
  const [loginName, setLoginName] = useState('');
  const [password, setPassword] = useState('');
  const [csrfToken, setCsrfToken] = useState('');
  const [errors, setErrors] = useState({ loginName: '', password: '' });
  const navigate = useNavigate();

  const apiUrl = '/api';  // Updated to relative path

  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get(`${apiUrl}/csrf-token`, { withCredentials: true });
        console.log('CSRF token fetched successfully:', response.data.csrfToken);
        setCsrfToken(response.data.csrfToken);
      } catch (error) {
        console.error('Failed to fetch CSRF token:', error.message, error.response?.data);
        setMessage('Failed to fetch CSRF token. Please refresh the page.');
      }
    };
    fetchCsrfToken();
  }, [setMessage]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage('');
    setErrors({ loginName: '', password: '' });

    const trimmedLoginName = loginName.trim();
    const trimmedPassword = password.trim();

    const newErrors = { loginName: '', password: '' };
    if (!trimmedLoginName) newErrors.loginName = 'Login name is required';
    if (!trimmedPassword) newErrors.password = 'Password is required';

    if (Object.values(newErrors).some(error => error)) {
      setErrors(newErrors);
      return;
    }

    if (!csrfToken) {
      setMessage('CSRF token not available. Please refresh the page.');
      return;
    }

    try {
      const response = await axios.post(`${apiUrl}/login`, {
        loginName: trimmedLoginName,
        password: trimmedPassword,
      }, {
        headers: { 'X-CSRF-Token': csrfToken },
        withCredentials: true,
      });
      console.log('Login response:', response.data, 'Set-Cookie:', response.headers['set-cookie']);

      if (response.data.success) {
        setUserId(response.data.userId);
        setIsAuthenticated(true);
        setLoginName('');
        setPassword('');
        setMessage('Login successful!');

        // Clear the justLoggedOut flag on successful login
        localStorage.removeItem('justLoggedOut');

        // Verify cookie immediately
        const authResponse = await axios.get(`${apiUrl}/me`, { withCredentials: true });
        console.log('Post-login /api/me:', authResponse.data);

        navigate('/chat');
      } else {
        setMessage(response.data.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login request failed:', error.response?.data || error.message);
      setMessage(error.response?.data?.message || 'Login failed');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <form onSubmit={handleLogin}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="loginName">Login Name:</label>
              <input
                type="text"
                id="loginName"
                placeholder="Enter your login name"
                value={loginName}
                onChange={(e) => setLoginName(e.target.value)}
              />
            </div>
            {errors.loginName && <p className="error">{errors.loginName}</p>}
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="password">Password:</label>
              <input
                type="password"
                id="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            {errors.password && <p className="error">{errors.password}</p>}
          </div>

          <button type="submit">Login</button>
        </form>
      </div>
    </div>
  );
}

export default Login;